import connect from 'react-redux/es/connect/connect';
import { I18n } from 'react-redux-i18n';

import UserDetails from '../components/UserDetails';
import * as actions from '../actions/UserDetailsActions';
import * as mainActions from '../actions';
import * as cpActions from "../actions/ChangePasswordActions"
import { MessageBoxTypes } from "../const/ActionsConst";

const mapStateToProps = (state, ownProps) => {
    return state.userDetails
};

const mapDispatchToProps = (dispatch) => {
    return {
        onUpdateProperty: (username, property, value) => {
            dispatch(actions.updateProperty(username, property, value));
        },
        onUpdateInput: (property, value) => {
            dispatch(actions.updateInput(property, value));
        },
        funcLoadProfiles: () => dispatch(actions.loadProfiles()),
        onDeleteUserClick: (username) => dispatch(
            mainActions.showMessageBoxBasedOnData(
                MessageBoxTypes.DELETE_USER, 
                true, 
                I18n.t('Delete ID') + ' - ' + username, I18n.t('Are you sure you want to delete this user'), 
                I18n.t('Delete User'),
                I18n.t('Cancel'), 
                'small'
            )
        ),
        onChangePasswordClick: (username) => dispatch(cpActions.showChangePasswordWnd(true, username)),
        onClearMfaTrustedDevices: (username) => dispatch(actions.clearMfaTrustedDevices(username)),
        settingsMethods: {
            security: {
                onChange: (username, classes) => {
                    dispatch(actions.updateUserSecurity(username, classes));
                },
            },
            licensing: {
                onChange: (username, useClassBased, licensing) => {
                    dispatch(actions.updateLicensing(username, useClassBased, licensing));
                },
            },
            formats: {
                onChange: (username, data) => {
                    dispatch(actions.updateFormats(username, data));
                },
            }
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDetails);

